import client from '../thinMintClient'
import { resolvePayoutDown } from './resolver'
import { Payout, ServerPayout } from './types'

export const baseEndpoint = '/payouts'

export const getPayouts = () =>
  client
    .get<{ results: ServerPayout[] }>(`${baseEndpoint}/`)
    .then((res) => res.data.results.map(resolvePayoutDown) as Payout[])
